import {combineReducers} from "redux";
import clientReducer from "./clientReducer";
import periodReducer from "./periodReducer"
import fileUploadReducer from "./fileUploadReducer";
import commonReducer from "./commonReducer";
import userReducer from "./userReducer";
import notificationReducer from "./notificationReducer";
import litigationReducer from "./litigationReducer"
import facilitationReducer from "./facilitationReducer"
import hsnSacReducer from "./hsnSacReducer"


const rootReducer = combineReducers({ 
        clients: clientReducer,
        periods: periodReducer,
        files: fileUploadReducer, 
        common: commonReducer,
        user: userReducer,
        notification: notificationReducer,
        litigation: litigationReducer,
        facilitation:facilitationReducer,
        hsnSac: hsnSacReducer,
    });

export default rootReducer